import { CreateCohortCard } from "@pathwright/web/src/modules/cohort/create/CreateCohort"
import TeachGate from "@pathwright/web/src/modules/home/teach/TeachGate"
import { getDefaultLaunchedFromHome } from "../lib/core/routing/utils"
import { onEnterHome } from "../unified-home/routes"
import HomeOrLibraryBrowse from "./components/HomeOrLibraryBrowse"

const { createCardRoutes } = require("lib/core/routing/card-routing")

export const createCohortCardRoute = createCardRoutes(
  "/home/teach/",
  {
    create: {
      component: CreateCohortCard,
      getDefaultLaunchedFrom: getDefaultLaunchedFromHome
    }
  },
  HomeOrLibraryBrowse
)

export default [
  {
    path: "/home/:section/:subSection?/",
    onEnter: onEnterHome,
    component: (props) => (
      <HomeOrLibraryBrowse
        {...props}
        section={props.match.params.section}
        subSection={props.match.params.subSection}
        nodeKey={props.location.query.id}
      />
    )
  },
  {
    path: "/home/teach/activate/",
    getDefaultLaunchedFrom: () => "/home/teach/",
    components: {
      modal: TeachGate,
      primary: require("./components/HomeOrLibraryBrowse").default
    }
  }
]
